import React from 'react';
import { compose } from 'ramda';
import styleFile from './Image.js';
import PropertyManager from '../../HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { withContent } from '../../providers/translateProvider';
import { ReactSVG } from 'react-svg';

const Image = class Image extends React.Component {

  static displayName = 'Image';
  render() {
    const { config, theme } = this.props;
    const { classes } = theme.styles;

    const onClick = typeof config.onClick === 'function' ? config.onClick : () => { };
    let componentImage;
    if (config.content) {
      componentImage = (
        <span
          className={theme.computedInnerStyle}
          style={{ fontFamily: config.fontFamily || 'Icons' }}
          onClick={onClick}>
          {' '}
          {config.content}
        </span>
      );
    } else if (config.unicodeContent) {
      componentImage = (
        <span
          className={theme.computedInnerStyle}
          style={{ fontFamily: config.fontFamily || 'Icons' }}
          dangerouslySetInnerHTML={{ __html: '&#x' + config.unicodeContent + ';' }}
          onClick={onClick}
        />
      );
    } else if (config.backgroundImage) {
      componentImage = (
        <div
          className={theme.computedInnerStyle}
          style={{ backgroundImage: 'url(' + config.backgroundImage + ')' }}
          onClick={onClick}>
            {this.props.children}
            <img
              loading={config.loading ? config.loading : 'eager'}
              alt={config.alt}
              className={classes.accesibilityImage}
              src={config.backgroundImage}
            />
        </div>
      );
    } else if (config.svgSync) {
      const getSvg = this.props.content.getSvg;
      const Svg = getSvg(config.svgSync);
      componentImage = <Svg innerStyle={theme.computedInnerStyle} onClick={onClick} />;
    } else if (config.svg) {
      componentImage = <ReactSVG 
      beforeInjection={(svg) => {
        svg.removeAttribute("role");
        // Add a class name to the SVG element. Note: You'll need a classList
        // polyfill if you're using this in older browsers.
        var lol = theme.computedInnerStyle.split(" ");
        lol.forEach((element) => {
            element && svg.classList.add(element)
        });

      }} src={`${document.location.origin}/assets/svg/${config.svg}.svg`} />;
    } else {
      componentImage = (
        <img
          loading={config.loading ? config.loading : 'eager'}
          alt={config.alt}
          className={theme.computedInnerStyle}
          src={config.src}
          onClick={onClick}
        />
      );
    }

    return componentImage;
  }
};

export default compose(
  PropertyManager([
    'config',
    'src',
    'alt',
    'button',
    'backgroundImage',
    'content',
    'unicodeContent',
    'noDefaultStyle',
    'svg',
    'onClick',
    'onMouseEnter',
    'loading',
    'svgSync'
  ]),
  withThemeJSS({ styleFile, link: true }),
  withContent('svg')
)(Image);
